module.exports = __webpack_public_path__ + "static/media/Zentia-Anti-Slavery-Statement-22-12-15.f8e7ca43.pdf";